import { Button } from '@/shared/ui/button'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import Link from 'next/link'
import { HTMLAttributes } from 'react'
export interface ProductNotificationInfoReachedProps {
  notificationPrice: number
  link: string
}

export const ProductNotificationInfoReached = ({
  className,
  notificationPrice,
  link,
  ...props
}: ProductNotificationInfoReachedProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn('flex flex-col gap-4', className)} {...props}>
      <div className="flex items-center justify-between">
        <div>
          <div>
            <p className="text-heading-02-bold">설정하신 알림가에</p>
            <p className="text-heading-02-bold">도달했어요!</p>
          </div>
          <p className="mt-4">
            알림가{' '}
            <span className="text-primary">
              {notificationPrice.toLocaleString()}원
            </span>
            에
          </p>
        </div>
        <Image
          src={'/icons/상품상세_벨_도달.svg'}
          alt={''}
          width={60}
          height={60}
        />
      </div>
      <Button
        variant="outlinePrimary"
        className="h-fit rounded-full py-2"
        asChild
      >
        <Link target="_blank" href={link}>
          쿠팡에서 구매하기
        </Link>
      </Button>
    </div>
  )
}
